import R from 'ramda'

/**
 * Update a folder's name and/or description
 * @param {Object} folder - Information about the folder to be updated
 * @param {number} folder.id - The ID of the folder to be updated
 * @param {string} folder.name - The updated name to apply
 * @param {string} folder.description - The updated description to apply
 * @param {Array} folders - The array of folders from the current state
 */
export default function({ id, name, description }, folders) {
  const index = R.findIndex(R.propEq('id', id), folders)

  // findIndex returns -1 if index not found
  if (index < 0) throw new Error(`updateFolder: id ${id} not found in array`)

  // Folder at `index` passed as second arg to R.mergeLeft
  return R.adjust(index, R.mergeLeft({ name, description }), folders)
}
